import React from 'react';

function Header(props) {
  const { title, children } = props;
  return (
    <div className='margin_bottom_20 d-flex justify-content-between'>
      <h1 className='section_head'>{title}</h1>
      {children}
    </div>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/views/ESG/Header/index.jsx